<template>
  <q-page class="q-pt-lg">
    <div class="text-center">
      <h1 class="text-center">{{$t('pages.select.theyAreWorking')}}</h1>
      <div class="q-mt-xs">
        <span class="text-color2">{{$t('pages.select.currentTime')}}:&nbsp;</span>
        <span>{{liveTime}}</span>
      </div>
    </div>

    <div class="search-area q-pl-md q-pr-md">
      <div class="max-width-limited2 full-height">
        <div class="q-mt-lg flex items-center justify-between row full-height">
          <input
            type="text"
            :placeholder="$t('pages.select.searchInput')"
            class="input-text search-area__1 q-pl-md q-pr-md q-mr-sm border-rounded"
            spellcheck="false"
            v-model="inputValue"
          />
          <!--<q-input color="$primary" v-model="text" class="search-area__1" label="fdgdf">
            <template v-slot:append>
              <q-icon name="close" />
            </template>
          </q-input>
          -->
          <input
            type="text"
            class="input-text search-area__2 q-pl-md q-pr-md q-mr-sm border-rounded"
            spellcheck="false"
          />
          <q-btn :label="$t('pages.select.findButton')" type="submit" color="primary" class="button search-area__3" no-caps />
        </div>
      </div>
    </div>

    <div class="max-width-limited2 q-mb-xl">
      <div
        class="workers row justify-start q-gutter-y-lg q-mt-lg q-pb-lg"
        v-if="!loginDialogVisible && workers && workers.length"
      >
        <div
          v-for="worker in sortedWorkers"
          v-bind:key="worker.id"
          class="workers__card border-rounded shadowed"
          :class="{
            'another-shop': isDiffShop(worker.employees),
            'outsource': (worker.network && worker.network.name) !== (network && network.name)
          }"
          @click="openModal(worker)"
        >

          <div class="q-pa-md">
            <div class="workers__card__avatar full-width border-rounded q-mb-sm flex justify-center">
              <img
                v-if="worker.avatar"
                style="max-height: 240px; width: 100%; object-fit: cover;"
                :src="isElectron() ? apiUrl + worker.avatar : worker.avatar"
                class="border-rounded"
              />
              <img
                v-else
                style="max-height: 240px; width: 100%; object-fit: cover;"
                src="../statics/user-no-avatar.png"
                class="border-rounded"
              />
            </div>

            <div class="text-center">
              <div class="workers__card__name q-mb-sm semi-bold">{{worker.last_name}} {{worker.first_name}} {{worker.middle_name || ''}}</div>
              <div v-if="worker.employees[0].worker_days.length" class="q-mb-sm">
                <div class="text-color2">{{$t('pages.select.workTime')}}:</div>
                <div
                  v-for="day in worker.employees[0].worker_days"
                  :key="day.id"
                >
                  {{$t('pages.select.from')}} {{dtNormalize(day.dttm_work_start)}} {{$t('pages.select.till')}} {{dtNormalize(day.dttm_work_end)}}
                </div>
              </div>
              <div class="text-color2">
                {{ worker.network && worker.network.name === network && network.name ? $t('pages.select.department') : $t('pages.select.company') }}
              </div>
              <div>{{getShopName(worker.employees)}}</div>

              <div v-if="worker.ticks && worker.ticks.t1" class="q-mt-sm">
                <div class="text-color2">{{$t('pages.select.ticks')}}</div>
                <span class="q-mr-sm">
                  <span class="text-color2">{{$t('pages.select.coming')}}: </span>
                  <span v-if="worker.ticks.t1" :class="getTimeColor(worker.ticks, 'late')">{{worker.ticks.t1}}</span>
                  <span v-else>???</span>
                </span>
                <span class="q-ml-sm">
                  <span class="text-color2">{{$t('pages.select.leaving')}}: </span>
                  <span v-if="worker.ticks.t2" :class="getTimeColor(worker.ticks, 'dumped')">{{worker.ticks.t2}}</span>
                  <span v-else>???</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <q-dialog v-model="isOpenModal">
      <q-card style="width: 650px; max-width: 80vw;">
        <q-card-section class="row items-center q-pb-none text-right justify-between q-px-lg">
          <div class="text-h6">{{ $t('pages.select.selectEmployee') }}</div>
          <q-btn icon="close" flat round dense v-close-popup />
        </q-card-section>

        <q-card-section>
          <div class="row justify-center q-my-md">
            <div
              v-for="empl in selectedWorker.employees"
              :key="empl.tabel_code"
              class="border-rounded shadowed q-pa-lg q-ma-md empl-card text-center"
              @click="selectEmployee(empl.id)"
            >
              <div class="q-mb-sm">
                <div class="text-color2">{{$t('pages.select.position')}}:</div>
                {{ empl.position || $t('pages.select.noPosition') }}
              </div>
              <div class="q-mb-sm">
                <div class="text-color2">{{$t('pages.select.tabelCode')}}:</div>
                <div>{{empl.tabel_code || $t('pages.select.noTabelcode')}}</div>
              </div>
              <div v-if="empl.worker_days.length && empl.worker_days[0].dttm_work_start && empl.worker_days[0].dttm_work_end">
                <div
                  v-for="day in empl.worker_days"
                  :key="day.id"
                >
                  <div class="q-mb-sm">
                    <div class="text-color2">{{$t('pages.select.workTime')}}:</div>
                    {{$t('pages.select.from')}} {{dtNormalize(day.dttm_work_start)}} {{$t('pages.select.till')}} {{dtNormalize(day.dttm_work_end)}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>

    <q-dialog :value="loginDialogVisible && !errorModal.enabled" persistent>
      <q-card style="min-width: 400px">
        <q-card-section>
          <div class="text-h6">Код для доступа к системе</div>
        </q-card-section>
        <q-card-section>
          <q-input dense v-model="accessCode" autofocus @keyup.enter="checkAccessCode()" />
        </q-card-section>
        <q-card-actions align="right" class="text-primary">
          <q-btn
            v-if="apiUrl"
            color="#fff"
            text-color="grey-9"
            icon="logout"
            @click="clearApiUrl"
          />
          <div style="margin: auto;"></div>
          <q-btn flat label="Ок" @click="checkAccessCode()" />
        </q-card-actions>
      </q-card>
    </q-dialog>

    <q-dialog v-model="apiPrompt" persistent>
      <q-card style="min-width: 400px">
        <q-card-section>
          <div class="text-h6">Пожалуйста укажите адрес API сервера</div>
        </q-card-section>
        <q-card-section>
          <q-input dense v-model="apiInput" autofocus @keyup.enter="onApiInput" />
        </q-card-section>
        <q-card-actions align="right" class="text-primary">
          <q-btn flat label="Ок" @click="onApiInput" />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
import { colors } from 'quasar'
import { mapState } from 'vuex'
import { API_REQUEST } from '../api.js'
import logo from '../assets/img/logo-mind-and-machine.png'
import { formDate, isElectron } from '../common/helpers'
import { sendInfoException } from '../modules/sentry-api'
import { markPerfEvent } from '../modules/urv-perf'

export default {
  name: 'SelectWorker',

  props: {
    apiUrl: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      liveTime: '',
      accessCode: '',
      isOpenModal: false,
      selectedWorker: {},
      inputValue: '',
      clockTimer: null,
      apiInput: '',
      loggedIn: false,
      loginDialogVisible: false,
      isElectron
    }
  },

  computed: {
    ...mapState([
      'shop',
      'network',
      'errorModal',
      'comingLatenessShift',
      'leavingDumpnessShift',
      'style',
      'workers'
    ]),

    sortedWorkers () {
      if (!this.workers) {
        return []
      }
      return this.workers.filter(w => {
        if (w.firstLastName.includes(this.inputValue)) {
          return true
        }
        if (w.lastFirstName.includes(this.inputValue)) {
          return true
        }
        return false
      })
    },

    getShopName () {
      return (employees) => {
        if (!employees || !employees.length) {
          return ''
        }
        const hasSimilar = employees.some(empl => empl.shop && empl.shop.id === this.shop && this.shop.id)
        if (hasSimilar) {
          return this.shop.name
        } else {
          const name = employees[0].shop ? employees[0].shop.name : ''
          return name
        }
      }
    },

    isDiffShop () {
      return (employees) => {
        if (!employees || !employees.length) {
          return true
        }
        if (!this.shop) {
          return false
        }
        const hasSimilar = employees.some(empl => empl.shop && empl.shop.id === this.shop.id)
        if (!hasSimilar) {
          return true
        }
      }
    },

    hasApiUrl () {
      return process.env.API || process.env.DEV_PROXY_TARGET || this.apiUrl
    },

    apiPrompt () {
      return isElectron() && !this.hasApiUrl
    }
  },

  watch: {
    inputValue (val) {
      if (val === ' ') {
        this.inputValue = ''
        return
      }
      this.inputValue = val.toLowerCase()
    },

    loggedIn (val) {
      if (val) {
        this.$store.commit('setIsFailedFetchTics', false)
      }
    },

    async apiPrompt (val, oldVal) {
      if (val) {
        this.loginDialogVisible = false
      }
      if (oldVal && !val) {
        await this.makeFirstRequest()
      }
    }
  },

  async mounted () {
    window.addEventListener('onUpdateNeeded', this.onUpdateNeeded)

    this.setAppStyle({})
    this.handleClock()
    await this.checkCurrentTickPoint()

    await this.makeFirstRequest()
  },

  beforeDestroy () {
    window.removeEventListener('onUpdateNeeded', this.onUpdateNeeded)
    if (this.clockTimer) {
      clearInterval(this.clockTimer)
    }
  },

  methods: {
    async makeFirstRequest () {
      try {
        await this.$store.dispatch('fetchWorkers', { isForce: true })
        await this.startApp()
      } catch (err) {
        this.defaultErrorHandler(err)
      }
    },

    getTimeColor (ticks, lateOrDumped) {
      if (ticks.OFFLINE) {
        return ''
      }
      if (lateOrDumped === 'late') {
        return ticks.late ? 'bad-worker' : 'good-worker'
      }
      if (lateOrDumped === 'dumped') {
        return ticks.dumped ? 'bad-worker' : 'good-worker'
      }
    },

    async openModal (worker) {
      if (worker.employees.length === 1) {
        this.fixWorker({
          ...worker,
          employee_id: worker.employees[0].id
        })
      } else if (worker.employees.length > 1) {
        this.isOpenModal = true
        this.selectedWorker = worker
      }
    },

    selectEmployee (emplId) {
      const worker = {
        ...this.selectedWorker,
        employee_id: emplId
      }
      this.fixWorker(worker)
    },

    fixWorker (worker) {
      this.$store.commit('setSelectedWorker', worker)
      this.$router.push('fix')
    },

    dtNormalize (isoDt) {
      const d = formDate(isoDt)
      return d.getHours() + ':' + String(d.getMinutes()).padStart(2, '0')
    },

    handleClock () {
      const timeZone = this.shop && this.shop.timezone
      const params = { hour: '2-digit', minute: '2-digit' }
      if (timeZone) {
        params.timeZone = timeZone
      }
      function getCurrentTimeHHMM () {
        const today = new Date()
        const time = today.toLocaleString('ru-RU', params)
        return time
      }
      this.liveTime = getCurrentTimeHHMM()
      let oldTime = ''
      this.clockTimer = setInterval(() => {
        const timeHHMM = getCurrentTimeHHMM()
        if (timeHHMM !== oldTime) {
          this.liveTime = timeHHMM
          oldTime = timeHHMM
        }
      }, 3000)
    },

    onApiInput () {
      localStorage.setItem('apiUrl', this.apiInput)
    },

    async checkCurrentTickPoint () {
      let response

      try {
        response = await API_REQUEST('getCurrentTickPoint')
      } catch (e) {
        if (e.http_status === 403) {
          if (this.apiPrompt) {
            this.loginDialogVisible = false
            return
          }
          this.loginDialogVisible = true
        } else {
          this.handleHttpError(e)
        }
        return
      }

      if (response.http_status === 200) {
        await this.login({
          shop: response.shop,
          network: response.network,
          tickPoint: response.tick_point
        })
      } else {
        this.handleHttpError(response)
      }
    },

    async checkAccessCode () {
      let response
      if (this.apiPrompt) {
        this.loginDialogVisible = false
        return
      }

      try {
        response = await API_REQUEST('tokenAuth', { key: this.accessCode.trim() })
      } catch (e) {
        this.handleHttpError(e)
        return
      }

      if (response.http_status === 200 && response.shop) { // if success
        await this.login({
          shop: response.shop,
          network: response.network,
          tickPoint: response.tick_point
        })
      } else {
        this.$store.commit('setIsFailedFetchTics', true)
        this.handleHttpError(response)
      }
    },

    handleHttpError (error) {
      const errorMessage = error
        ? error.detail || JSON.stringify(error)
        : JSON.stringify(error)
      this.showError(errorMessage)
      this.showError(JSON.stringify(error))
    },

    async login ({ shop, network, tickPoint }) {
      this.loggedIn = true
      this.loginDialogVisible = false

      this.$store.commit('setShop', { ...shop })
      this.$store.commit('setNetwork', { ...network })
      this.$store.commit('setTickPoint', { ...tickPoint })

      this.setAppStyle(network)
      this.handleClock()

      try {
        await this.startApp()
      } catch (e) {
        this.defaultErrorHandler(e)
      }
    },

    logout () {
      this.loggedIn = false
      this.$store.commit('setWorkers', [])
      if (this.apiPrompt) {
        this.loginDialogVisible = false
        return
      }
      this.loginDialogVisible = true
    },

    setAppStyle (res) {
      const localStyle = this.style

      if (res['primary_color'] || localStyle.primaryColor) {
        colors.setBrand('primary', res['primary_color'] || localStyle.primaryColor)
        document.documentElement.style.setProperty('--q-color-primary', res['primary_color'] || localStyle.primaryColor)
        localStyle.primaryColor = res['primary_color'] || localStyle.primaryColor
      }
      if (res['secondary_color'] || localStyle.secondaryColor) {
        colors.setBrand('secondary', res['secondary_color'] || localStyle.secondaryColor)
        document.documentElement.style.setProperty('--q-color-secondary', res['secondary_color'] || localStyle.secondaryColor)
        localStyle.secondaryColor = res['secondary_color'] || localStyle.secondaryColor
      }
      if (res.logo || localStyle.logo || logo) {
        localStyle.logo = res.logo || localStyle.logo || logo
      }

      this.$store.commit('setStyle', localStyle)
    },

    showError (msg) {
      if ((typeof msg === 'object' && !Object.keys(msg).length) || msg === '{}' || this.apiPrompt) {
        return
      }
      this.$store.commit('setErrorModal', {
        enabled: true,
        message: msg
      })
    },

    async startApp () {
      this.$store.commit('setFirstPicsPaused', false)

      this.$store.commit('setComingLeavingShifts', {
        comingLatenessShift: 0
      })
      await this.$store.dispatch('fetchWorkers')
      await this.$store.dispatch('fetchTicks')

      markPerfEvent('ready_for_next_checkin', {})
    },

    defaultErrorHandler (error) {
      let reportedError = error

      const errorStatus = error.details ? error.details.httpStatus : error.http_status
      if ([401, 403].includes(errorStatus)) {
        this.logout()
        reportedError = new Error(`Unauthorized with token: ${localStorage.getItem('K2')}`)
      }

      sendInfoException(reportedError)
    },

    async onUpdateNeeded (event) {
      console.warn('event fired: onUpdateNeeded.', event)
      if (event.detail.updateSubject === 'getFilteredTicks') {
        try {
          await this.startApp()
        } catch (err) {
          this.defaultErrorHandler(err)
        }
      }
    },

    clearApiUrl () {
      localStorage.removeItem('apiUrl')
    }
  }
}
</script>

<style lang="stylus">
.empl-card
  cursor: pointer
  transition: .1s
  border-radius: 3px
  width: 250px
  &:hover
    background-color: #def0f0
.search-area
  width: 100%
  background-color: $bg-color2
  height: 72px
  .input-text
    height: 40px
    outline: none
    border: 0
    background-color: $bg-color
    font-size: 16px
    &::placeholder
      color: $text-color2
  .button
    height: 40px
    box-shadow: none
  &__1
    width: "calc(60% - %s)" % $min-margin
  &__2
    width: "calc(20% - %s)" % $min-margin
    position: relative
  &__3
    width: 20%
.workers
  width: "calc(100% + %s)" % $cards-gutter
  margin-left: - ($cards-gutter)

  &__card
    width: 276px
    min-height: 455px
    background-color: $bg-color
    cursor: pointer
    margin-left: $cards-gutter
    transition: .1s

    &__avatar
      height: 240px

    &__name
      font-size: 16px
    &:hover
      background-color: #def0f0
    & .good-worker
      color: green
    & .bad-worker
      color: red

.another-shop
  background-color: #6b173857
  &:hover
    background-color: #6b173833

.outsource
  background-color: #ff1e0038
  &:hover
    background-color: #ff1e0026

@media screen and (max-width: 880px)
  .workers
    justify-content: center
    margin-left: - ($cards-gutter / 2)
    &__card
      margin-left: $cards-gutter
</style>
